import { createContext, useContext, useEffect, useState } from 'react';

const GenericModal = createContext({});

export const GenericModalProvider = ({ children }) => {
  //Context state
  const [genericModal, setGenericModal] = useState();
  const [genericModalMobileFloat, setGenericModalMobileFloat] = useState();

  const [genericModalSelectionState, setGenericModalSelectionState] =
    useState();
  const [genericModalSelectionStateId, setGenericModalSelectionStateId] =
    useState();
  const [invalidSelection, setInvalidSelection] = useState(false);

  //UI state
  const [closeModalFocusId, setCloseModalFocusId] = useState();

  let resetTimer;

  //UI functions
  useEffect(() => {
    if (genericModal) {
      document.body.style.overflowY = 'hidden';
      return () => {
        document.body.style.overflowY = 'scroll';
      };
    }
  }, [genericModal]); //removes scroll when component mounts so theres not two scroll bars

  //Context functions
  function handleCloseModal() {
    let el;
    if (closeModalFocusId) {
      el = document.getElementById(`${closeModalFocusId}`);
    }

    if (el) {
      el.focus();
    }
    setCloseModalFocusId();

    if (genericModal) {
      setGenericModal();
    } else if (genericModalMobileFloat) {
      setGenericModalMobileFloat();
    }

    if (invalidSelection) {
      resetTimer = setTimeout(() => {
        setInvalidSelection(false);
        clearTimeout(resetTimer);
      }, 1500);
    }
  }

  return (
    <GenericModal.Provider
      value={{
        genericModal,
        setGenericModal,
        handleCloseModal,
        setCloseModalFocusId,
        genericModalMobileFloat,
        setGenericModalMobileFloat,
        genericModalSelectionState,
        setGenericModalSelectionState,
        genericModalSelectionStateId,
        setGenericModalSelectionStateId,
        invalidSelection,
        setInvalidSelection,
      }}
    >
      {children}
    </GenericModal.Provider>
  );
};

export const useGenericModal = () => {
  return useContext(GenericModal);
};
